import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import EquipmentAlertViewMonitoringPage from 'components/inner/EquipmentAlertViewMonitoringPage';
import { getMaintenanceTasksById } from 'components/axios/maintenanceAxios';
import { useQuery } from '@tanstack/react-query';
import Error404 from 'pages/Error404';

const MaintenanceHistoryViewMonitoring = () => {
    const {id} = useParams();

    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        setNotFound(false);
    }, [id]);

    const { data, isLoading, isError, refetch } = useQuery({
        queryKey: ['equipmentDetail', id],
        queryFn: () => getMaintenanceTasksById(id),

        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled: !!id,
        onError: (error) => {
            if (error?.response?.status === 404) {
                setNotFound(true);
            }
        }
    });

    if (isLoading) return <div>Loading...</div>;

    if (notFound) {
        return <Error404 />;
    }

    return (
        <EquipmentAlertViewMonitoringPage alertId={data?.equipmentAlert?.id} />
    )
}

export default MaintenanceHistoryViewMonitoring;